// import { useState } from "react";
// import {
//   Card,
//   CardHeader,
//   CardContent,
//   IconButton,
//   Typography,
//   Box,
//   Tooltip,
// } from "@mui/material";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// const HolidayCalendar = ({ data, setDate, date }) => {
//   const today = new Date();
//   const [currentMonth, setCurrentMonth] = useState(today.getMonth());
//   const [currentYear, setCurrentYear] = useState(today.getFullYear());

//   const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
//   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//   const monthName = new Date(currentYear, currentMonth).toLocaleString(
//     "default",
//     { month: "long" },
//   );

//   const prevMonth = () => {
//     setCurrentMonth((prev) => {
//       if (prev === 0) {
//         setCurrentYear((y) => y - 1);
//         return 11;
//       }
//       return prev - 1;
//     });
//   };

//   const nextMonth = () => {
//     setCurrentMonth((prev) => {
//       if (prev === 11) {
//         setCurrentYear((y) => y + 1);
//         return 0;
//       }
//       return prev + 1;
//     });
//   };

//   const isHoliday = (date) => {
//     const dateStr = date.toLocaleDateString("en-CA");
//     return data?.currentMonthHolidays?.find((h) => h.eventDate === dateStr);
//   };

//   const isWeekoff = (date) => {
//     const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
//     return data?.currentWeekoffDays?.some((d) =>
//       d.weekoffDays
//         .split(",")
//         .map((day) => day.trim())
//         .includes(dayName),
//     );
//   };

//   const totalCells = 42;
//   const cells = [];

//   for (let i = 0; i < totalCells; i++) {
//     const dateNum = i - firstDayOfMonth + 1;
//     if (dateNum < 1 || dateNum > daysInMonth) {
//       cells.push(<Box key={`empty-${i}`} sx={{ width: 34, height: 36 }} />);
//     } else {
//       const date = new Date(currentYear, currentMonth, dateNum);
//       const holiday = isHoliday(date);
//       const weekoff = isWeekoff(date);
//       const isToday =
//         date.getDate() === today.getDate() &&
//         date.getMonth() === today.getMonth() &&
//         date.getFullYear() === today.getFullYear();

//       let bgColor = "#fff";
//       let color = "#333";
//       if (holiday) {
//         bgColor = "#FFD6A5";
//         color = "#8B4513";
//       } else if (weekoff) {
//         bgColor = "#c0baeaff";
//         color = "#6D61B1";
//       }

//       // const cell = (
//       //   <Box
//       //     key={i}
//       //     onClick={() =>
//       //       setDate(
//       //         `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
//       //           date.getDate(),
//       //         ).padStart(2, "0")}`,
//       //       )
//       //     }
//       //     // ⭐ THIS IS THE MAIN CHANGE
//       //     sx={{
//       //       backgroundColor: bgColor,
//       //       borderRadius: "8px",
//       //       width: 36,
//       //       height: 34,
//       //       display: "flex",
//       //       justifyContent: "center",
//       //       alignItems: "center",
//       //       fontSize: "11px",
//       //       color,
//       //       border: isToday ? "2px solid #6D61B1" : "1px solid #eee",
//       //       transition: "0.2s",
//       //       cursor: "pointer", // ⭐ ALL DATES CLICKABLE
//       //       "&:hover": {
//       //         transform: "scale(1.05)",
//       //         boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//       //       },
//       //     }}
//       //   >
//       //     {dateNum}
//       //   </Box>
//       // );
//       const isSelectedDate = (d) => {
//         if (!date) return false;
//         const selected = new Date(date); // date = YYYY-MM-DD
//         return (
//           d.getDate() === selected.getDate() &&
//           d.getMonth() === selected.getMonth() &&
//           d.getFullYear() === selected.getFullYear()
//         );
//       };

//       const cell = (
//         <Box
//           key={i}
//           onClick={() =>
//             setDate(
//               `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//                 2,
//                 "0",
//               )}-${String(date.getDate()).padStart(2, "0")}`,
//             )
//           }
//           sx={{
//             backgroundColor: bgColor,
//             borderRadius: "8px",
//             width: 36,
//             height: 34,
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             fontSize: "11px",
//             color,

//             // ✅ SELECTED DATE BORDER (FILTER INDICATOR)
//             border: isSelectedDate(date)
//               ? "2px solid #FF6F61"
//               : isToday
//                 ? "2px solid #6D61B1"
//                 : "1px solid #eee",

//             transition: "0.2s",
//             cursor: "pointer",

//             "&:hover": {
//               transform: "scale(1.08)",
//               boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//             },
//           }}
//         >
//           {dateNum}
//         </Box>
//       );

//       cells.push(
//         holiday ? (
//           <Tooltip key={i} title={holiday.event} arrow placement="top">
//             {cell}
//           </Tooltip>
//         ) : (
//           cell
//         ),
//       );
//     }
//   }

//   return (
//     <Card
//       sx={{
//         borderRadius: "14px",
//         boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
//         background: "linear-gradient(135deg, #f7f5ff, #ece9ff)",
//         width: "100%",
//         p: 0.5,
//       }}
//     >
//       <CardHeader
//         title={
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <IconButton size="small" onClick={prevMonth}>
//               <ChevronLeftIcon sx={{ color: "#6D61B1", fontSize: 20 }} />
//             </IconButton>
//             <Typography
//               variant="subtitle1"
//               sx={{ color: "#6D61B1", fontWeight: "bold", fontSize: "14px" }}
//             >
//               {monthName} {currentYear}
//             </Typography>
//             <IconButton size="small" onClick={nextMonth}>
//               <ChevronRightIcon sx={{ color: "#6D61B1", fontSize: 20 }} />
//             </IconButton>
//           </Box>
//         }
//         sx={{ pb: 0 }}
//       />

//       <CardContent sx={{ p: 1 }}>
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: "repeat(7, 1fr)",
//             gap: "2px",
//             textAlign: "center",
//             justifyItems: "center",
//           }}
//         >
//           {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
//             <Typography
//               key={d}
//               sx={{
//                 fontWeight: "bold",
//                 color: "#6D61B1",
//                 fontSize: "11px",
//                 mb: "3px",
//               }}
//             >
//               {d}
//             </Typography>
//           ))}
//           {cells}
//         </Box>

//         <Box
//           sx={{
//             mt: 1,
//             fontSize: "11px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             gap: 2,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//             <Box
//               sx={{
//                 width: 10,
//                 height: 10,
//                 borderRadius: 1,
//                 background: "#FFD6A5",
//               }}
//             />
//             Holiday
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//             <Box
//               sx={{
//                 width: 10,
//                 height: 10,
//                 borderRadius: 1,
//                 background: "#b8b3dbff",
//               }}
//             />
//             Weekoff
//           </Box>
//         </Box>
//       </CardContent>
//       <Typography sx={{ fontSize: "11px", mt: 0.5, textAlign: "center" }}>
//         Selected Date: <b>{date || "None"}</b>
//       </Typography>
//     </Card>
//   );
// };

// export default HolidayCalendar;


import { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const HolidayCalendar = ({ data, setDate, date }) => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());

  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  const monthName = new Date(currentYear, currentMonth).toLocaleString(
    "default",
    { month: "long" }
  );

  const prevMonth = () => {
    setCurrentMonth((prev) => {
      if (prev === 0) {
        setCurrentYear((y) => y - 1);
        return 11;
      }
      return prev - 1;
    });
  };

  const nextMonth = () => {
    setCurrentMonth((prev) => {
      if (prev === 11) {
        setCurrentYear((y) => y + 1);
        return 0;
      }
      return prev + 1;
    });
  };

  const isHoliday = (d) => {
    const dateStr = d.toLocaleDateString("en-CA");
    return data?.currentMonthHolidays?.find(
      (h) => h.eventDate === dateStr
    );
  };

  const isWeekoff = (d) => {
    const dayName = d.toLocaleDateString("en-US", { weekday: "long" });
    return data?.currentWeekoffDays?.some((w) =>
      w.weekoffDays
        .split(",")
        .map((x) => x.trim())
        .includes(dayName)
    );
  };

  // ✅ selected date checker (defined ONCE)
  const isSelectedDate = (d) => {
    if (!date) return false;
    const selected = new Date(date);
    return (
      d.getDate() === selected.getDate() &&
      d.getMonth() === selected.getMonth() &&
      d.getFullYear() === selected.getFullYear()
    );
  };

  const totalCells = 42;
  const cells = [];

  for (let i = 0; i < totalCells; i++) {
    const dateNum = i - firstDayOfMonth + 1;

    if (dateNum < 1 || dateNum > daysInMonth) {
      cells.push(<Box key={`empty-${i}`} sx={{ width: 36, height: 34 }} />);
      continue;
    }

    const d = new Date(currentYear, currentMonth, dateNum);
    const holiday = isHoliday(d);
    const weekoff = isWeekoff(d);

    const isToday =
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear();

    let bgColor = "#fff";
    let textColor = "#333";

    if (holiday) {
      bgColor = "#FFD6A5";
      textColor = "#8B4513";
    } else if (weekoff) {
      bgColor = "#c0baeaff";
      textColor = "#6D61B1";
    }

    const cell = (
      <Box
        key={i}
        onClick={() =>
          setDate(
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
              2,
              "0"
            )}-${String(d.getDate()).padStart(2, "0")}`
          )
        }
        sx={{
          backgroundColor: bgColor,
          borderRadius: "8px",
          width: 36,
          height: 34,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "11px",
          color: textColor,
          cursor: "pointer",

          // ⭐ VISUAL FILTER INDICATOR
          border: isSelectedDate(d)
            ? "2px solid #FF6F61"
            : isToday
            ? "2px solid #6D61B1"
            : "1px solid #eee",

          transition: "0.2s",
          "&:hover": {
            transform: "scale(1.08)",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          },
        }}
      >
        {dateNum}
      </Box>
    );

    cells.push(
      holiday ? (
        <Tooltip key={i} title={holiday.event} arrow placement="top">
          {cell}
        </Tooltip>
      ) : (
        cell
      )
    );
  }

  return (
    <Card
      sx={{
        borderRadius: "14px",
        boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
        background: "linear-gradient(135deg, #f7f5ff, #ece9ff)",
        width: "100%",
        p: 0.5,
      }}
    >
      <CardHeader
        sx={{ pb: 0 }}
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton size="small" onClick={prevMonth}>
              <ChevronLeftIcon sx={{ color: "#6D61B1", fontSize: 20 }} />
            </IconButton>

            <Typography
              sx={{
                color: "#6D61B1",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {monthName} {currentYear}
            </Typography>

            <IconButton size="small" onClick={nextMonth}>
              <ChevronRightIcon sx={{ color: "#6D61B1", fontSize: 20 }} />
            </IconButton>
          </Box>
        }
      />

      <CardContent sx={{ p: 1 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            gap: "2px",
            justifyItems: "center",
            textAlign: "center",
          }}
        >
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
            <Typography
              key={d}
              sx={{
                fontWeight: "bold",
                color: "#6D61B1",
                fontSize: "11px",
                mb: "3px",
              }}
            >
              {d}
            </Typography>
          ))}
          {cells}
        </Box>

        <Box
          sx={{
            mt: 1,
            fontSize: "11px",
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: 1,
                background: "#FFD6A5",
              }}
            />
            Holiday
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: 1,
                background: "#c0baeaff",
              }}
            />
            Weekoff
          </Box>
        </Box>

        <Typography sx={{ fontSize: "11px", mt: 0.5, textAlign: "center" }}>
          Selected Date: <b>{date || "None"}</b>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default HolidayCalendar;
